import React, { useState } from "react";
import { withRouter } from "react-router";
import { Grid, Row, Col } from "react-flexbox-grid/dist/react-flexbox-grid";
import Dialog from "material-ui/Dialog";
import TextField from "material-ui/TextField";
import Snackbar from "material-ui/Snackbar";
import FontIcon from "material-ui/FontIcon";
import Select from "@material-ui/core/Select";
import "react-flexbox-grid/dist/react-flexbox-grid.css";
import "./RequestCallback.css";
import user from "../assets/images/user.png";
import { Icon } from "@material-ui/core";

const styles = {
  gridList: {
    height: "auto",
  },
  customContentStyle: {
    width: "100%",
    minWidth: "320px",
  },
};
const countryCodeArray = [
  {
    name: "India",
    code: "91",
    image: "assets/images/flag_india.png",
    id: "IN",
    maxLength: 10,
  },
  {
    name: "UAE",
    code: "971",
    image: "assets/images/flag_uae.png",
    id: "AE",
    maxLength: 9,
  },
  {
    name: "USA",
    code: "1",
    image: "assets/images/flag_usa.png",
    id: "US",
    maxLength: 10,
  },
  {
    name: "UK",
    code: "44",
    image: "assets/images/flag_uk.png",
    id: "GB",
    maxLength: 10,
  },
  {
    name: "Canada",
    code: "1",
    image: "assets/images/flag_canada.png",
    id: "CA",
    maxLength: 10,
  },
  {
    name: "Australia",
    code: "61",
    image: "assets/images/flag_australia.png",
    id: "AU",
    maxLength: 9,
  },
];

async function getIP(data) {
  if (typeof window !== "undefined" && localStorage.getItem(data) == null) {
    let response = await fetch("https://www.cloudflare.com/cdn-cgi/trace", {
      mode: "cors",
    });
    let text = await response.text();
    localStorage.setItem(
      "country",
      text
        .split("\n")
        .filter((el) => el.startsWith("loc"))
        .join("\n")
        .slice(4)
    );
    //Location - AE- United Arab Emirates, AU- Australia, GB- United Kingdom, IN- India, CA- Canada, US- United States

    localStorage.setItem(
      "ip",
      text
        .split("\n")
        .filter((el) => el.startsWith("ip"))
        .join("\n")
        .slice(3)
    );
  }
  return returnData(data);
}

async function returnData(data) {
  if (typeof window !== "undefined" && data == "ip") {
    return localStorage.getItem("ip");
  } else if (typeof window !== "undefined" && data == "loc") {
    return countryCodeArray.find(
      (country) => localStorage.getItem("country") === country.id
    );
  }
}

class AssessmentForm extends React.Component {
  constructor(props) {
    super();

    this.state = {
      deviceMobile: false,
      dialogView: "default",
      countryCode: "91",
      maxLength: "10",
      submitting: false,
      user: {
        phoneNo: "",
        name: "",
        email: "",
      },
      error: {
        phoneNo: "",
        name: "",
        email: "",
      },
      snackbar: {
        open: false,
        message: "",
      },
    };
  }
  componentDidMount() {
    getIP("loc").then((data) => {
      this.setCountryCode(data.code, data.maxLength);
    });
  }
  componentWillReceiveProps(props) {
    this.setState({ deviceMobile: props.deviceMobile, dialogView: "default" });
  }

  syncState = (event) => {
    let phoneNo, name, email;
    switch (event.target.name) {
      case "phoneNo":
        phoneNo = parseInt(event.target.value);
        name = this.state.user.name;
        email = this.state.user.email;
        this.setState({
          user: {
            phoneNo: phoneNo,
            name: name,
            email: email,
          },
        });
        break;
      case "name":
        phoneNo = this.state.user.phoneNo;
        name = event.target.value;
        email = this.state.user.email;
        this.setState({
          user: {
            phoneNo: phoneNo,
            name: name,
            email: email,
          },
        });
        break;
      case "email":
        phoneNo = this.state.user.phoneNo;
        name = this.state.user.name;
        email = event.target.value;
        this.setState({
          user: {
            phoneNo: phoneNo,
            name: name,
            email: email,
          },
        });
        break;
      default:
        break;
    }
  };

  reset() {
    this.setState({
      user: {
        phoneNo: "",
        name: "",
        email: "",
      },
      submitting: "",
    });
  }

  handleSubmit = async () => {
    // event.preventDefault();

    this.setState({ submitting: true });
    if (this.state.user.name) {
      if (this.validatePhoneNo(this.state.user.phoneNo, this.state.maxLength)) {
        // if (this.validateEmail(this.state.user.email)) {
        this.setState({
          user: this.state.user,
          error: {
            phoneNo: "",
            name: "",
            // email: "",
          },
        });

        let user = this.state.user;
        user.who = this.props.who;

        await this.submitUserLead(this.state.user);
      } else {
        this.setState({
          user: this.state.user,
          error: {
            phoneNo: "Please enter a valid phone number",
            name: "",
            email: this.state.error.email,
          },
          submitting: false,
        });
      }
    } else {
      this.setState({
        user: this.state.user,
        submitting: false,
        error: {
          phoneNo: this.state.error.email,
          name: "Please enter a valid name",
          email: this.state.error.email,
        },
      });
    }
  };

  submitUserLead = async (user) => {
    await fetch("https://zyla.in/api/requestCallback", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: user.name,
        phoneNo: user.phoneNo,
        url: window.location.href,
      }),
    });
    try {
      let that = this;
      let endpoint = process.env.REACT_APP_API_URL + "/leads/new";
      let url = new URLSearchParams(window.location.search);
      let urlParams = new URLSearchParams(url);
      let leadBody = {
        phoneno: user.phoneNo,
        name: user.name,
        email: "user@examle.com",
        who: user.who,
        countryCode: this.state.countryCode,
        utm: window.location.search,
        utm2: urlParams.get("utm2"),
        utmSource: urlParams.get("utm_source"),
        path: window.location.href,
      };

      let subLeadResp = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          client: "main_web",
        },
        body: JSON.stringify(leadBody),
      });

      if (subLeadResp.status !== 200) {
        this.setState({ dialogView: "fail" });
      } else {
        let data = await subLeadResp.json();
      }

      this.setState({ submitting: false });
      // done here
      // this.props.history.push("/thanks");
      window.location.href = "/thanks";
      setTimeout(
        function () {
          that.reset();
          that.props.handleClose();
        }.bind(this),
        2000
      );
    } catch (err) {
      this.setState({ dialogView: "fail", submitting: false });
    }
  };
  setCountryCode(code) {
    let country = countryCodeArray.find((country) => country.code === code);
    this.setState({ countryCode: code, maxLength: country.maxLength });
  }
  validateEmail(email) {
    let re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validatePhoneNo(phoneNo, maxLength) {
    var re;
    if (maxLength == 9) {
      re = /^\d{9}$/;
    } else if (maxLength == 10) {
      re = /^\d{10}$/;
    }
    return re.test(phoneNo);
  }

  showSnackBar = (message) => {
    this.setState({
      snackbar: {
        open: true,
        message: message,
      },
    });
  };

  render() {
    const { dialogView, deviceMobile, countryCode, maxLength } = this.state;
    const { phoneNo, email } = this.state.user;

    return (
      <Dialog
        className="dialog-callback"
        modal={true}
        open={this.props.open}
        autoScrollBodyContent={true}
      >
        <FontIcon
          style={{ cursor: "pointer", position: "absolute", right: "20px" }}
          onClick={() => this.props.handleClose()}
          className="material-icons"
        >
          close
        </FontIcon>
        {dialogView === "default" && (
          <div>
            <div style={{ textAlign: "center", paddingBottom: "26px" }}>
              <img alt="user" style={{ display: "inline" }} src={user} />
            </div>

            <div style={{ textAlign: "center", paddingBottom: "20px" }}>
              <label className="title-diag">
                {this.props.heading
                  ? this.props.heading
                  : "Talk to Medical Expert"}
              </label>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "-webkit-center",
                paddingBottom: "30px",
              }}
            >
              {!this.props.subTitle && (
                <div className="desc-diag">
                  We are eager to understand your health and help you in the
                  most customized way.
                  {/*
                {this.props.description} */}
                </div>
              )}

              <br />

              <div className="sec-desc-diag">
                {this.props.subTitle
                  ? this.props.subTitle
                  : "Please provide below details and our medical expert will call you shortly."}
              </div>
            </div>

            <Row
              style={{
                paddingBottom: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Col
                xs={12}
                sm={12}
                md={6}
                lg={6}
                // className="md:mr-1"
                style={{
                  padding: 0,
                  paddingRight: "1rem",
                  marginTop: "1rem",
                }}
              >
                <TextField
                  className="name-field"
                  hintText="Name"
                  inputStyle={{ paddingLeft: "0.4rem" }}
                  // floatingLabelText="Name"
                  floatingLabelFixed={true}
                  type="text"
                  name="name"
                  value={this.state.user.name}
                  errorText={this.state.error.name}
                  onChange={this.syncState}
                  style={{
                    outline: "none",
                    height: "50px",
                    width:
                      this.props.width && this.props.width < 600
                        ? "107%"
                        : "100%",
                    // paddingLeft: "0.4rem",
                  }}
                />
              </Col>

              <Col
                xs={12}
                sm={12}
                md={6}
                lg={6}
                style={{
                  display: "flex",
                  marginRight: "0px",

                  flexFlow: "row",
                  padding: "0",
                  marginTop: "1rem",
                }}
                className="phone-wrapper"
              >
                <Select
                  native
                  defaultValue={this.state.countryCode}
                  value={this.state.countryCode}
                  onChange={(e) => this.setCountryCode(e.target.value)}
                  className="select-code"
                  style={{
                    borderLeft: "0px solid #c4c4c4",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                  }}
                >
                  {countryCodeArray.map((country) => (
                    <option style={{ zIndex: "100000" }} value={country.code}>
                      +{country.code}
                    </option>
                  ))}
                </Select>
                <TextField
                  className="phone-field"
                  hintText="  Phone Number"
                  // floatingLabelText="Phone Number"
                  floatingLabelFixed={true}
                  // inputStyle={{ paddingLeft: "0.4rem" }}
                  type="number"
                  name="phoneNo"
                  value={this.state.user.phoneNo}
                  errorText={this.state.error.phoneNo}
                  onChange={this.syncState}
                  maxlength={maxLength}
                  style={{ maxWidth: "80%" }}
                />
              </Col>
            </Row>
            <Row style={{ justifyContent: "center" }}>
              {this.state.submitting ? (
                <div className="requested-callback" label="Submit">
                  Submitting
                </div>
              ) : (
                <div
                  className="requested-callback"
                  label="Submit"
                  onClick={() => {
                    // this.setState({ dialogView: "success" });
                    this.handleSubmit();
                  }}
                >
                  Request Callback
                </div>
              )}
            </Row>

            <Snackbar
              open={this.state.snackbar.open}
              message={this.state.snackbar.message}
              autoHideDuration={2000}
            />
          </div>
        )}
        {dialogView === "fail" && (
          <div>
            <Row style={{ display: "flex", paddingBottom: "20px" }}>
              <Col
                xs={12}
                sm={12}
                md={6}
                lg={6}
                style={{ textAlign: "center", alignSelf: "center" }}
              >
                <img alt="alert" src={"/assets/icons/alert-circle.svg"}></img>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6}>
                <div style={{ alignSelf: "center" }}>
                  <div style={{ paddingBottom: "20px" }}>
                    <label className="title-success">
                      Something went wrong!
                    </label>
                  </div>
                  <div style={{ paddingBottom: "20px" }}>
                    <label className="desc-success">
                      There seems to be an error in submission.
                      <br /> Please try requesting again.
                    </label>
                  </div>
                  <div>
                    <label
                      className="message-success"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.setState({ dialogView: "default" });
                      }}
                    >
                      Request Callback again
                    </label>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}
        {dialogView === "success" && (
          <div>
            <Row style={{ display: "flex", paddingBottom: "20px" }}>
              <Col
                xs={12}
                sm={12}
                md={4}
                lg={4}
                style={{ textAlign: "center" }}
              >
                <img
                  alt="success"
                  src={"/assets/icons/success.svg"}
                  height="170px"
                  width="170px"
                ></img>
              </Col>
              <Col
                xs={12}
                sm={12}
                md={8}
                lg={8}
                style={{ alignSelf: "center" }}
              >
                <div style={{ paddingBottom: "20px" }}>
                  <label className="title-success">
                    Successfully received!
                  </label>
                </div>
                <div style={{ paddingBottom: "20px" }}>
                  <label className="desc-success">
                    We have successfully received your request for callback and
                    will reach back to you at the earliest.
                  </label>
                </div>
                <div>
                  <label className="message-success">
                    Have a healthy day ahead!
                  </label>
                </div>
              </Col>
            </Row>
          </div>
        )}
        {dialogView === "alreadyExists" && (
          <div>
            <Row
              style={{
                display: "flex",
                paddingBottom: "20px",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <div style={{ paddingBottom: "20px" }}>
                <label className="title-success">
                  Callback already requested.
                </label>
              </div>
              <div style={{ paddingBottom: "20px" }}>
                <label className="desc-success">
                  You've already requested the callback on this number (
                  {phoneNo}).
                </label>
              </div>
              <div>
                <label
                  className="message-success"
                  style={{ cursor: "pointer", fontSize: "1rem" }}
                  onClick={() => {
                    this.setState({ dialogView: "default" });
                  }}
                >
                  Request callback on different number
                </label>
              </div>
            </Row>
          </div>
        )}
      </Dialog>
    );
  }
}

export const RequestCallbackCTA = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="request-callback-cta" onClick={() => setOpen(true)}>
        <div className="request-callback-online"></div>
        Talk to Medical Expert
      </div>
      <AssessmentForm open={open} handleClose={() => setOpen(false)} />
    </>
  );
};

export default withRouter(AssessmentForm);
